// TODO: validate option value type
import React from "react";
import Fade from 'react-bootstrap/Fade';
import {
  isValidInteger,
  isValidFloat,
  getUuidv4
} from "../shared/form_attribute_utils";
import Sortable from 'react-sortablejs';

const PLACEHOLDER_OPTION = "__placeholder_option__";

function MetadataTypeName(props) {
  /**
   * modelName
   * value
   * onChangeEvent
   * errorMsg
   */

  return (<div className="form-group row">
      <label 
        className='col-md-6 col-form-label'>
          Name for metadata
        <small 
          className="form-text text-muted">
            name must start with a letter<br />
            all other characters must be letter, numbers or underscore
        </small>
      </label>
      <div className="col-md-6">
        <input
          name={`${props.modelName}[name]`}
          type="text"
          className={`form-control ${!!props.error ? 'is-invalid' : ''}`}
          value={props.value}
          disabled={props.disabled}
          onChange={props.onChangeEvent} />
        <div className="invalid-feedback">
          {props.error}
        </div>
      </div>
    </div>);
}

function MetadataTypeValueType(props) {
  return (
    <div className="form-group row">
      <label className='col-md-6 col-form-label'>Value type</label>
      <div className="col-md-6">
        <select
          name={`${props.modelName}[value_type]`}
          disabled={props.disabled}
          defaultValue={props.value}
          onChange={props.onChangeEvent}
          className="form-control">
          {props.options.map((type,index) => (
            <option
              key={index}
              value={type}>{type}</option>))}
        </select>
      </div>
    </div>);
}

function MetadataTypeOption(props) {
  // TODO: validate value type for option
  const option = props.option;
  let containerClassArr = option.destroy ? ['d-none'] : ['list-group-item'];
  if (!option.isValid){
    containerClassArr.push('is-invalid');
  }
  return (
  <li
    data-id={option.uuid}
    className={containerClassArr.join(" ")}>
    <div className="row">
      <div className="col-10">
        <input
          type="text"
          value={option.value}
          name={`${props.inputNamespace}[metadata_type_options_attributes][${props.index}][value]`}
          onChange={props.onUpdateOption}
          className={`form-control ${ option.isValid ? '' : 'is-invalid'}`}
        />
        { option.isValid ? undefined : <div className="invalid-feedback">not valid</div> }
        { option.id 
        ? <input
            type="hidden" 
            name={`${props.inputNamespace}[metadata_type_options_attributes][${props.index}][id]`}
            value={option.id} />
        : undefined
        }
        <input
          type="hidden"
          value={(props.index+1)}
          name={`${props.inputNamespace}[metadata_type_options_attributes][${props.index}][position]`}
        />
      </div>
      <div className="col-2">
      { option.destroy // do we need to adjust this?
      ? <input 
          type="hidden"
          name={`${props.inputNamespace}[metadata_type_options_attributes][${props.index}][_destroy]`}
          value="1"
          />
      : <button
          type="button"
          className="btn btn-danger btn-sm"
          onClick={() => {props.onDeleteOption(option.index)}}>
            <i className="fas fa-trash-alt"></i>
        </button>
      }
      </div>
    </div>
  </li>);
}

const OptionModel = {
  value: undefined,
  position: undefined,
  id: undefined,
  destroy: false
}

export default class MetadataTypeEditor extends React.Component{
  /**
   * TODO:
   * validate name - cannot be blank, must be 
   * do we need 
   */

  constructor(props){
    super(props);
    console.log('props:', props);
    let options_source = undefined;
    if (!!props.metadata_type.id) { // this is being edited
      if (props.metadata_type.display_type === 'singleselect') {
        if (!!props.metadata_type.selectable_uuid) {
          options_source = "external";
        } else { // TODO: convert to metadata_type_options
          options_source = "internal";
        }
      }
    } else {
      // this is a new metadata type so it might not even have an option source, leave undefined
    }

    let metadataAvailTo; //should be ALL, ONE, NONE (undefined)
    if (props.metadata_type.association_uuid === props.keenform.uuid ){
      metadataAvailTo = "all";
    } else if (!!props.metadata_type.association_uuid){ //should be explicitly matched, but could be null/undefined
      metadataAvailTo = "one";
    }

    const metadataOptions = ( props.metadata_type.options 
      ? props.metadata_type.options.map(opt => {
        return {
          ...opt,
          uuid: getUuidv4()
        };
      })
      : []
    );
    this.state = {
      name: props.metadata_type.name || "",
      display_type: props.metadata_type.display_type || undefined, // required
      value_type: props.metadata_type.value_type || "text",                 // not required, only applicable for singleselect & multiselect
      association_uuid: props.metadata_type.association_uuid || undefined,
      selectable_uuid: props.metadata_type.selectable_uuid || undefined,
      options_source: options_source,
      options: metadataOptions,
      metadata_avail_to: metadataAvailTo,
      editable: !props.metadata_type.id,
      number_precision: props.metadata_type.number_precision || 1
    };
  }

  setToAllOptions = () => {
    this.setState({
      association_uuid: this.props.keenform.uuid,
      metadata_avail_to: "all"
    });
  }

  setToOneOption = () => {
    this.setState({
      metadata_avail_to: "one",
      association_uuid: PLACEHOLDER_OPTION
    });
  }

  addOption = () => {
    // create dummy uuid
    const optionsQty = this.state.options.length;
    const newOption = {
      ...OptionModel,
      position: (optionsQty + 1),
      uuid: getUuidv4()
    };
    this.setState({
      options: this.state.options.concat([newOption])
    });
  }

  deleteOption = (index) => {
    const updatedOptions = this.state.options.map((option, i) => {
      return {
        ...option,
        destroy: (i === index ? true : option.destroy)
      };
    });
    this.setState({ options: updatedOptions });
  }

  optionIsValidPerValueType = (option_value, value_type) => {
    switch(value_type) {
      case "integer":
        return isValidInteger(option_value); //option_value == parseInt(option_value);
      case "float":
      case "decimal":
        return isValidFloat(option_value);
      case "currency":
        // TODO: make sure it is a float with 2 decimal points
        return isValidFloat(option_value);
      case "text":
        return true;
      default:
        console.error('invalid value type for selectable');
        return false;
    }
  } 

  setOptionState = (optionSource) => {
    let newState = {options_source: optionSource};
    // if optionSource === internal then add an empty option
    if (optionSource === "internal" && this.state.options.length == 0) {
      newState.options = [].concat({
        ...OptionModel,
        value: ''
      });
    }
    if (optionSource === "internal" && !this.state.value_type){
      // set value type to TEXT
      newState.value_type = "text";
    }
    this.setState(newState);
  }

  sortOptions = (uuidArray) => {
    const optionsSorted = uuidArray.map((thisUuid, index) => {
      const thisOption = this.state.options.find(opt => opt.uuid === thisUuid);
      return {
        ...thisOption,
        position: index + 1
      };
    });
    this.setState({options: optionsSorted});
  }

  updateOption = (index, event) => {
    let updatedOptions = this.state.options,
    thisOption = this.state.options[index];
    updatedOptions[index] = {
      ...thisOption,
      value: event.target.value
    };
    this.setState({
      options: updatedOptions
    });
  }

  render() {
    let inputNamespace = "metadata_type";
    if (this.state.association_uuid === this.props.keenform.uuid){
      inputNamespace = "keenform_option_metadata";
    } else if (!!this.state.association_uuid){
      inputNamespace = "form_attribute_option_metadata";
    }

    // validate name attribute
    let nameError;
    if (!this.state.name || this.state.name.length === 0){
      nameError = "name cannot be blank";
    } else if (this.state.name.search(/^[a-zA-Z][a-zA-Z0-9_]*$/) === -1){
      nameError = "name must start with letter, followed by letter, numbers and underscore";
    } else if (this.props.metadata_errors && this.props.metadata_errors.name){
      if (this.props.metadata_type.name === this.state.name){
        const errorMessage = this.props.metadata_errors.name[0];
        nameError = `the name '${this.state.name}' ${errorMessage}`;
      }
    }

    // validate option type value
    let valueTypeOptions = this.props.value_type_options;
    if (this.state.display_type === "number" ) {
      //only options available should be integer and float and currency
      valueTypeOptions = ['integer','float','currency'];
    } else if (this.state.display_type === "text" ) {
      valueTypeOptions = ['text'];
    } else { // this should not happen
      // hold off showing display type, probably singleselect
      console.warn('setting value type options has an issue due to unexpected display type');
    }

    // validate association_uuid
    const associationIsValid = (!!this.state.association_uuid && this.state.association_uuid !== PLACEHOLDER_OPTION);
    const displayTypeIsValid = (!!this.state.display_type && this.state.display_type !== PLACEHOLDER_OPTION);

    // check multiple inputs
    let isValid = nameError === undefined && associationIsValid;
    if (!displayTypeIsValid) {
      isValid = false;
    }

    // validate options
    const options = this.state.options.map( option => {
      const isValid = this.optionIsValidPerValueType(option.value, this.state.value_type);
      return {
        ...option,
        isValid: isValid
      };
    });
    const allOptionsAreValid = options.reduce( (isValid, option) => {
      return option.isValid && isValid
    }, true);
    if (allOptionsAreValid === false){
      isValid = false;
    }

    const showOptionSources = !!this.state.display_type && this.state.display_type.includes('select') && !this.props.metadata_type.id;
    return (
      <React.Fragment>
        { this.state.editable 
          ? undefined
          : <div className="alert alert-warning" role="alert">Some fields cannot be edited after creating the first time. If you need to edit any of these fields you must delete the metadata and create it again. </div>
         }
        <MetadataTypeName
          modelName={inputNamespace}
          value={this.state.name}
          error={nameError}
          disabled={!this.state.editable}
          onChangeEvent={(event) => {this.setState({name: event.target.value})}} />
        <div className="form-group row">
          <label className='col-md-6 col-form-label'>
            Make metadata available for
            <small 
              className="form-text text-muted">
                required - select one
            </small>
          </label>
          <div className="col-md-6">
            <div className={`btn-group ${associationIsValid ? '' : 'in-invalid'}`} role="group" aria-label="Apply metadata for">
              <button 
                type="button"
                onClick={this.state.editable ? this.setToAllOptions : undefined}
                disabled={!this.state.editable}
                className={`btn ${this.state.metadata_avail_to === "all" ? 'btn-primary' : 'btn-light'}`}>All Options</button>
              <button 
                type="button"
                disabled={!this.state.editable}
                onClick={this.state.editable ? this.setToOneOption : undefined}
                className={`btn ${this.state.metadata_avail_to === "one" ? 'btn-primary' : 'btn-light' }`}>Option for Single Form Attribute</button>
            </div>
            { !this.state.metadata_avail_to
              ? <div className="alert alert-danger" role="alert">you must selet one</div>
              : undefined
            }
          </div>
        </div>
        <Fade
          mountOnEnter={false}
          unmountOnExit={true}
          in={this.state.metadata_avail_to === "one"}>
          <div className="form-group row">
            <label className='col-md-6 col-form-label'>
              Which form attribute will this metadata be available for?
            </label>
            <div className="col-md-6">
              <select
                name={`${inputNamespace}[association_uuid]`}
                value={this.state.association_uuid}
                onChange={ event => this.setState({association_uuid: event.target.value})}
                className={`form-control ${ associationIsValid ? 'is-valid' : 'is-invalid'}`}>
                  <option>select a form attribute to add metadata</option>
                {this.props.association_options
                  .filter(type => type.uuid !== this.props.keenform.uuid)
                  .map( (type, index) => {
                    console.log('type:', type);
                    let inlineStyle = 'block';
                    if (this.state.metadata_avail_to === "one" && type.model === "Keenform" ){
                      console.log('hide this one', );
                      inlineStyle = 'none'; // this is hiding it, but why?
                    } else {
                      console.log('leave as is');
                    }
                    return (<option
                      key={index}
                      style={{display: inlineStyle}}
                      value={type.value}>{type.label}</option>);
                  })
                }
              </select>
              <div className="invalid-feedback">
                this field is required
              </div>
            </div>
          </div>
        </Fade>
        <div className="form-group row">
          <label className='col-md-6 col-form-label'>
            What kind of input type for metadata type?
            <small 
              className="form-text text-muted">
                display type of metadata
            </small>
          </label>
          <div className="col-md-6">
            <select
              name={`${inputNamespace}[display_type]`}
              disabled={!this.state.editable}
              value={this.state.display_type}
              onChange={ event => this.setState({display_type: event.target.value})}
              className={`form-control ${this.state.display_type !== PLACEHOLDER_OPTION ? 'is-valid' : 'is-invalid'}`}>
              <option>select a display type</option>
              {this.props.display_type_options.map((type,index) => (
                <option
                  key={index}
                  value={type}>{type}</option>))}
            </select>
            <div className="invalid-feedback">
              this field is required
            </div>
          </div>
        </div>
        <Fade
          mountOnEnter={true}
          unmountOnExit={true}
          in={showOptionSources}>
          <div className="form-group row">
            <label className='col-md-6 col-form-label'>Options source</label>
            <div className="col-md-6">
              <div className="btn-group" role="group" aria-label="Options source">
                <button 
                  type="button"
                  onClick={ () => {this.setOptionState('internal') } }
                  className={`btn ${(this.state.options_source === "internal" ? 'btn-primary' : 'btn-light')}`}>
                    Create options</button>
                <button 
                  type="button"
                  onClick={ () => {this.setOptionState('external') } }
                  className={`btn ${this.state.options_source === "external" ? 'btn-primary' : 'btn-light' }`}>Use options from another form attribute</button>
              </div>
            </div>
          </div>
        </Fade>
        { this.state.display_type === "number" || 
          (["singleselect","multiselect"].includes(this.state.display_type) && this.state.options_source === "internal")
          ? <MetadataTypeValueType
              modelName={inputNamespace}
              disabled={!this.state.editable}
              value={this.state.value_type}
              options={valueTypeOptions}
              onChangeEvent={(event) => {this.setState({value_type: event.target.value})}} />
          : undefined
        }
        <Fade
          mountOnEnter={true}
          unmountOnExit={true}
          in={this.state.display_type === "number" && this.state.value_type === "float"}>
          <div className="form-group row">
            <label className='col-md-6 col-form-label'>
              Precision
              <small className="form-text text-muted">quantity of digits after decimal point</small>
            </label>
            <div className="col-md-6">
              <input
                name={`${inputNamespace}[number_precision]`}
                type="number"
                className="form-control"
                min="1"
                max="10"
                placeholder="maximum quantity of digits after decimal point"
                defaultValue={this.state.number_precision} />
            </div>
          </div>
        </Fade>
        { this.state.metadata_avail_to === "all" 
          ? <input type="hidden" name={`${inputNamespace}[association_uuid]`} value={this.props.keenform.uuid} />
          : undefined 
        }
        <Fade
          mountOnEnter={true}
          unmountOnExit={true}
          in={this.state.options_source === "internal"}>
          <div className="form-group row">
            <label className='col-md-6 col-form-label'>
              Set options for selectable:
            </label>
            <div className="col-md-6">
              <ul className="list-group">
                <Sortable
                  options={{
                    animation: 150,
                    group: {
                      name: 'options-sortable-list',
                      pull: false,
                      put: true
                    },
                  }}
                  onChange={(order, sortable, event) => {
                    this.sortOptions(order);
                  }
                }>
                  {
                    options.map(
                      (opt, index) => {
                        const isOptionValid = this.optionIsValidPerValueType(opt.value, this.state.value_type);
                        return <MetadataTypeOption
                          inputNamespace={inputNamespace}
                          index={index}
                          option={opt}
                          key={index}
                          onUpdateOption={(event) => this.updateOption(index, event)}
                          onDeleteOption={() => this.deleteOption(index) } />
                      }
                    )
                  }
                </Sortable>
              </ul>
              <button 
                className="btn btn-primary"
                type="button" 
                onClick={this.addOption}>add option</button>
            </div>
          </div>
        </Fade>
        <Fade
          mountOnEnter={true}
          unmountOnExit={true}
          in={this.state.options_source === "external"}>
          <div className="form-group row">
            <label className='col-md-6 col-form-label'>Select Form Attribute source</label>
            <div className="col-md-6">
              <select
                name={`${inputNamespace}[selectable_uuid]`}
                defaultValue={this.state.selectable_uuid}
                className="form-control">
                  {this.props.keenform.form_attributes
                    .filter(fa => fa.uuid !== this.state.association_uuid)
                    .filter(fa => ['singleselect','multiselect'].includes(fa.form_attribute_type))
                    .map((fa,index) => {
                    return <option value={fa.uuid} key={index}>{fa.name}</option>;
                  })}
              </select>
            </div>
          </div>
        </Fade>
        <div className="form-group row">
          <label className='col-md-6 col-form-label'>
            Position
            <small className="form-text text-muted">
              order in which metadata will appear on option
            </small>
          </label>
          <div className="col-md-6">
            <input
              name={`${inputNamespace}[position]`}
              type="number"
              className="form-control"
              defaultValue={this.props.metadata_type.position} />
          </div>
        </div>
        <div className="actions">
          <input 
            type="submit"
            value="Submit"
            disabled={isValid === false}
            className="btn btn-primary float-right" />
        </div>
      </React.Fragment>
    );
  }
}
